<template>
  <modal
    :header-text="$t('modal.addNewItem')"
    :button-text="$t('global.add')"
    @action="addNewItem()"
    @close="$emit('close')"
  >
    <div :class="$style.inputContainer">
      <label>{{ label }}</label>
      <input
        v-model="name"
        type="text"
        :class="$style.input"
      >
    </div>

    <div :class="$style.inputContainer">
      <label>{{ $t('global.category') }}</label>

      <select
        v-model="selectedCategory"
        :class="$style.input"
      >
        <option
          v-for="option in groups"
          :key="option.id"
          :value="option.id"
        >
          {{ getLabel(option.groupName) }}
        </option>
      </select>
    </div>
  </modal>
</template>

<script>
  import Vue from 'vue';
  import VueToast from 'vue-toast-notification';
  import Modal from '@/components/common/modal/category-modal.vue';
  import { addItem } from '@/api/methods/categories';
  import { getLabel } from '@/helpers/fields';

  Vue.use(VueToast);

  export default {
    components: { Modal },
    props: ['groups', 'type', 'apps'],
    data: () => ({
      name: '',
      selectedCategory: undefined,
    }),
    computed: {
      label() {
        if (this.type === 1) return this.$t('global.exeFileName');
        return this.$t('global.link');
      },
    },
    methods: {
      getLabel(label) {
        return getLabel(label);
      },
      close() {
        this.$emit('close');
      },
      async addNewItem() {
        const name = this.name.trim();
        if (name.length > 0) {
          if (this.selectedCategory) {
            const found = this.apps.find((app) => app.name === name);
            if (found) {
              if (this.type === 1) {
                Vue.$toast.open({
                  message: this.$t('toast.programAlreadyInList'),
                  type: 'error',
                });
              }
              if (this.type === 2) {
                Vue.$toast.open({
                  message: this.$t('toast.websiteAlreadyInList'),
                  type: 'error',
                });
              }
            } else {
              const result = await addItem(name, this.selectedCategory, this.type);
              if (result === 'success') this.name = '';
              this.$emit('update');
              this.close();
            }
          } else {
            Vue.$toast.open({
              message: this.$t('toast.selectCategory'),
              type: 'error',
            });
          }
        } else {
          if (this.type === 1) {
            Vue.$toast.open({
              message: this.$t('toast.enterExeFileName'),
              type: 'error',
            });
          }
          if (this.type === 2) {
            Vue.$toast.open({
              message: this.$t('toast.enterLink'),
              type: 'error',
            });
          }
        }
      },
    },
  };
</script>

<style lang="scss" module>
  .input {
    margin: 5px;
    width: 55%;
    border: 1px solid rgba(60, 60, 60, 0.26);
    border-radius: 4px;
    height: 30px;
  }
  .inputContainer {
    font-size: 13px;
    margin: 5px;
    display: flex;
    align-items: baseline;
    justify-content: space-between;
  }
</style>
